/* globals coursera */
// @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
export default coursera.courseId;
